import {_utils, viewportChecker} from "../utils/_utils.js";
import {_state} from "../state/state.js";

export const customSelect = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.fast-custom-dropdown', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (dropdown) => {
    const createDropdown = ()=> {
        const labelWrapper = dropdown.closest('label');
        const select = dropdown.querySelector('.fast-custom-dropdown__select');
        const customSelect = dropdown.querySelector('.fast-custom-dropdown__custom-select');

        const optionsContainer = document.createElement('div');
        optionsContainer.classList.add('fast-custom-dropdown__options');

        const updateHasValue = () => {
            if (select.value) {
                labelWrapper.classList.add('has-value');
                dropdown.classList.add('has-value');
            } else {
                labelWrapper.classList.remove('has-value');
                dropdown.classList.remove('has-value');
            }
        };

        select.querySelectorAll('option').forEach(option => {
            const optionDiv = document.createElement('div');
            optionDiv.classList.add('fast-custom-dropdown__option');
            optionDiv.textContent = option.textContent;
            optionDiv.dataset.value = option.value;

            optionDiv.addEventListener('click', () => {
                select.value = option.value;
                customSelect.textContent = option.textContent;

                optionsContainer.classList.remove('show');
                customSelect.classList.remove('open');

                updateHasValue();

                select.dispatchEvent(new Event('change', { bubbles: true }));
            });

            optionsContainer.appendChild(optionDiv);
        });

        dropdown.appendChild(optionsContainer);

        const selectedOption = select.querySelector('option:checked');
        customSelect.textContent = selectedOption ? selectedOption.textContent : select.options[0].textContent;

        updateHasValue();

        customSelect.addEventListener('click', () => {
            const isOpen = optionsContainer.classList.contains('show');
            document.querySelectorAll('.fast-custom-dropdown__options').forEach(opt => opt.classList.remove('show'));
            document.querySelectorAll('.fast-custom-dropdown__custom-select').forEach(sel => sel.classList.remove('open'));

            if (!isOpen) {
                optionsContainer.classList.add('show');
                customSelect.classList.add('open');
            }
        });

        document.addEventListener('click', (e) => {
            if (!dropdown.contains(e.target)) {
                optionsContainer.classList.remove('show');
                customSelect.classList.remove('open');
            }
        });
    }

    createDropdown();

}

